import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  font-family: Montserrat;
  border: 1px solid ${({ theme: { colors } }) => colors.b2cLightGrey};
  border-radius: 2px;
`;

export const SubContainer = styled.div<{ isMobile?: boolean }>`
  height: 6rem;
  display: flex;
  padding: 0 0.9rem;
  font-size: 1.6rem;
  ${({ isMobile }) =>
    isMobile &&
    `
        font-size: 1.28rem;
    `}
`;

export const LoyaltyProgramContainer = styled(SubContainer)`
  flex-direction: column;
`;

export const Header = styled(SubContainer)`
  background-color: ${({ theme: { colors } }) => colors.b2cDarkWhite};
`;

export const Footer = styled(SubContainer)``;

export const SubContainerWrapper = styled.div`
  align-self: center;
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const HeaderText = styled.span`
  font-weight: 400;
  line-height: 1.6rem;
  text-transform: uppercase;
`;

export const BookingRef = styled.span`
  color: ${({ theme: { colors } }) => colors.b2cDarkBlack};
  font-weight: 600;
  line-height: 2rem;
`;

export const FooterText = styled.span`
  font-weight: 400;
  line-height: 3.4rem;
`;

export const Price = styled(FooterText)`
  color: ${({ theme: { colors } }) => colors.b2cDarkBlack};
  font-weight: 600;
`;

export const BookingDetailButton = styled.a`
  display: flex;
  cursor: pointer;
  font-size: 1.6rem;
  line-height: 2.4rem;
  font-weight: 600;
  box-sizing: border-box;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0.5rem 1.2rem;
  height: 3.4rem;
  width: 16.4rem;
  align-self: center;
  color: ${({ theme: { colors } }) => colors.white};
  background-color: ${({ theme: { colors } }) => colors.b2cRedThl};
  border: 0.1rem solid ${({ theme: { colors } }) => colors.b2cRedThl};
  border-radius: 0.2rem;

  :hover {
    background-color: ${({ theme: { colors } }) => colors.b2cLightOrange};
    border: 0.1rem solid ${({ theme: { colors } }) => colors.b2cLightOrange};
  }
  :active {
    background-color: ${({ theme: { colors } }) => colors.b2cDarkRed};
    border: 0.1rem solid ${({ theme: { colors } }) => colors.b2cDarkRed};
  }
`;
